<script>
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import {contacts} from "@js/company_details.ts";

export default {
    name: "PrivacyPolicyPage",
    components: {MobileTopBar, Breadcrumbs},
    setup(){
        return {
            contacts,
        }
    }
}
</script>

<template>
    <MobileTopBar/>
    <div class="container mx-auto">
        <Breadcrumbs class="mb-2"/>
        <h1 class="text-2xl md:text-3xl">
            Политика конфиденциальности
        </h1>
        <hr class="mt-5 mb-5"/>
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                Сбор и использование персональных данных
            </h2>
            <p class="text-sm mb-2">
                Администрация сайта metallolom1-prokat.ru обязуется сохранять вашу конфиденциальность в Интернете. Мы
                уделяем
                большое значение охране предоставленных вами данных. Наша политика конфиденциальности основана на
                требованиях Общего регламента о защите персональных данных Европейского Союза (GDPR). Цели, в
                которых мы
                собираем персональные данные: улучшение работы нашего сервиса, осуществление контактов с
                посетителями
                данного сайта, новостная рассылка по электронной почте, обработка данных пользователей для сервиса
                онлайн - торговли, предоставление информации, которую запрашивал пользователь, осуществление услуг,
                связанных с направлением деятельности данного сайта, а так же для указанных ниже действий.
            </p>
            <p class="text-sm mb-2">
                Мы собираем и используем ваши персональные данные только в случае вашего добровольного согласия. При
                согласии с этим вы разрешаете нам собирать и использовать следующие данные: имя и фамилия, дата
                рождения, электронная почта, номер телефона, домашний адрес, личные фотографии , данные банковской
                карточки, идентификаторы электронных кошельков, данные аккаунтов в социальных сетях, . Сбор и
                обработка
                ваших данных проводится соответствии с законами, действующими на территории Европейского Союза и в
                государстве Россия.
            </p>
        </div>
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                Хранение данных, изменение и удаление
            </h2>
            <p class="text-sm mb-2">
                Администрация сайта metallolom1-prokat.ru обязуется сохранять вашу конфиденциальность в Интернете. Мы
                уделяем
                большое значение охране предоставленных вами данных. Наша политика конфиденциальности основана на
                требованиях Общего регламента о защите персональных данных Европейского Союза (GDPR). Цели, в
                которых мы собираем персональные данные: улучшение работы нашего сервиса, осуществление контактов с
                посетителями данного сайта, новостная рассылка по электронной почте, обработка данных пользователей
                для сервиса онлайн - торговли, предоставление информации, которую запрашивал пользователь,
                осуществление услуг, связанных с направлением деятельности данного сайта, а так же для указанных
                ниже действий.
            </p>
            <p class="text-sm mb-2">
                Пользователь, предоставивший свои персональные данные сайту metallolom1-prokat.ru имеет право на их
                изменение и
                удаление, а так же на отзыв своего согласия с их использованием. Срок, в течение которого будут
                храниться ваши персональные данные: период хранения коммерческих и налоговых данных. При завершении
                использования ваших данных администрация сайта удаляет их. Для доступа к своим персональным данным
                вы можете связаться с администрацией сайта по следующему адресу: {{contacts.info_mail}} . Мы можем
                передавать ваши личные данные третьей стороне только с вашего добровольного согласия, если они были
                переданы, то изменение данных в других организациях, не связанных с нами, мы осуществить не можем.
            </p>
        </div>
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                Использование технических данных при посещении сайта
            </h2>
            <p class="text-sm mb-2">
                Администрация сайта metallolom1-prokat.ru обязуется сохранять вашу конфиденциальность в Интернете. Мы
                уделяем
                большое значение охране предоставленных вами данных. Наша политика конфиденциальности основана на
                требованиях Общего регламента о защите персональных данных Европейского Союза (GDPR). Цели, в
                которых мы собираем персональные данные: улучшение работы нашего сервиса, осуществление контактов с
                посетителями данного сайта, новостная рассылка по электронной почте, обработка данных пользователей
                для сервиса онлайн - торговли, предоставление информации, которую запрашивал пользователь,
                осуществление услуг, связанных с направлением деятельности данного сайта, а так же для указанных
                ниже действий.
            </p>
            <p class="text-sm mb-2">
                При посещении вами сайта metallolom1-prokat.ru в базе данных сохраняются записи о вашем IP адресе, времени
                посещения, настройках браузера, операционной системе, а также другая техническая информация
                необходимая для корректного отображения содержимого сайта. По этим данным нам невозможно
                идентифицировать личность посетителя.
            </p>
        </div>
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                Предоставление информации детьми
            </h2>
            <p class="text-sm mb-2">
                Администрация сайта metallolom1-prokat.ru обязуется сохранять вашу конфиденциальность в Интернете. Мы
                уделяем
                большое значение охране предоставленных вами данных. Наша политика конфиденциальности основана на
                требованиях Общего регламента о защите персональных данных Европейского Союза (GDPR). Цели, в
                которых мы собираем персональные данные: улучшение работы нашего сервиса, осуществление контактов с
                посетителями данного сайта, новостная рассылка по электронной почте, обработка данных пользователей
                для сервиса онлайн - торговли, предоставление информации, которую запрашивал пользователь,
                осуществление услуг, связанных с направлением деятельности данного сайта, а так же для указанных
                ниже действий.
            </p>
            <p class="text-sm mb-2">
                Если Вы являетесь родителем или опекуном, и вы знаете, что ваши дети предоставили нам свои личные
                данные без Вашего согласия, свяжитесь с нами: {{contacts.info_mail}}. На нашем сервисе запрещено
                оставлять
                личные данные несовершеннолетних без согласия родителей или опекунов.
            </p>
        </div>
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                Использование cookies
            </h2>
            <p class="text-sm mb-2">
                Администрация сайта metallolom1-prokat.ru обязуется сохранять вашу конфиденциальность в Интернете. Мы
                уделяем
                большое значение охране предоставленных вами данных. Наша политика конфиденциальности основана на
                требованиях Общего регламента о защите персональных данных Европейского Союза (GDPR). Цели, в
                которых мы собираем персональные данные: улучшение работы нашего сервиса, осуществление контактов с
                посетителями данного сайта, новостная рассылка по электронной почте, обработка данных пользователей
                для сервиса онлайн - торговли, предоставление информации, которую запрашивал пользователь,
                осуществление услуг, связанных с направлением деятельности данного сайта, а так же для указанных
                ниже действий.
            </p>
            <p class="text-sm mb-2">
                Для корректного отображения содержимого и для удобства использования сайта metallolom1-prokat.ru мы
                используем
                cookie файлы. Это небольшие файлы, которые хранятся на вашем устройстве. Они помогают сайту
                запомнить информацию о вас, например на каком языке вы просматриваете сайт и какие страницы вы уже
                открывали, эта информация будет полезна при следующем посещении. Благодаря файлам cookie просмотр
                сайта становится значительно более удобным. Подробнее про эти файлы вы можете прочитать тут. Вы
                можете настроить прием или блокировку cookie в браузере самостоятельно. Невозможность принимать
                cookie может ограничить работоспособность сайта.
            </p>
        </div>
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                Использование персональных данных другими сервисами
            </h2>
            <p class="text-sm mb-2">
                Администрация сайта metallolom1-prokat.ru обязуется сохранять вашу конфиденциальность в Интернете. Мы
                уделяем
                большое значение охране предоставленных вами данных. Наша политика конфиденциальности основана на
                требованиях Общего регламента о защите персональных данных Европейского Союза (GDPR). Цели, в
                которых мы собираем персональные данные: улучшение работы нашего сервиса, осуществление контактов с
                посетителями данного сайта, новостная рассылка по электронной почте, обработка данных пользователей
                для сервиса онлайн - торговли, предоставление информации, которую запрашивал пользователь,
                осуществление услуг, связанных с направлением деятельности данного сайта, а так же для указанных
                ниже действий.
            </p>
            <p class="text-sm mb-2">
                На этом сайте используются сторонние интернет-сервисы, осуществляющие независимый от нас сбор
                информации: Google Analytics , Yandex.Metrica, Yandex.Direct, Bitrix Analytics. Собранные ими данные
                могут предоставляться другим службам внутри этих организаций, они могут использовать данные для
                персонализации рекламы своей собственной рекламной сети. Вы можете прочитать пользовательские
                соглашения этих организаций на их сайтах. Там же вы можете отказаться от сбора ими персональных
                данных, к примеру блокировщик Google Analytics находится тут, блокировщик Яндекс Метрики тут. Мы не
                передаем персональные данные другим организациям и службам, не указанным в данной политике
                конфиденциальности. Исключение составляет только передача информации при законных требованиях
                государственных органов уполномоченных осуществлять данные действия.
            </p>
        </div>
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                Ссылки на другие сайты
            </h2>
            <p class="text-sm mb-2">
                Администрация сайта metallolom1-prokat.ru обязуется сохранять вашу конфиденциальность в Интернете. Мы
                уделяем
                большое значение охране предоставленных вами данных. Наша политика конфиденциальности основана на
                требованиях Общего регламента о защите персональных данных Европейского Союза (GDPR). Цели, в
                которых мы собираем персональные данные: улучшение работы нашего сервиса, осуществление контактов с
                посетителями данного сайта, новостная рассылка по электронной почте, обработка данных пользователей
                для сервиса онлайн - торговли, предоставление информации, которую запрашивал пользователь,
                осуществление услуг, связанных с направлением деятельности данного сайта, а так же для указанных
                ниже действий.
            </p>
            <p class="text-sm mb-2">
                Наш сайт metallolom1-prokat.ru может содержать ссылки на другие сайты, которые не управляются нами. Мы не
                несем
                ответственность за их содержание. Мы рекомендуем вам ознакомиться с политикой конфиденциальности
                каждого сайта, который вы посещаете, если она там есть.
            </p>
        </div>
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                Изменения в политике конфиденциальности
            </h2>
            <p class="text-sm mb-2">
                Администрация сайта metallolom1-prokat.ru обязуется сохранять вашу конфиденциальность в Интернете. Мы
                уделяем
                большое значение охране предоставленных вами данных. Наша политика конфиденциальности основана на
                требованиях Общего регламента о защите персональных данных Европейского Союза (GDPR). Цели, в
                которых мы собираем персональные данные: улучшение работы нашего сервиса, осуществление контактов с
                посетителями данного сайта, новостная рассылка по электронной почте, обработка данных пользователей
                для сервиса онлайн - торговли, предоставление информации, которую запрашивал пользователь,
                осуществление услуг, связанных с направлением деятельности данного сайта, а так же для указанных
                ниже действий.
            </p>
            <p class="text-sm mb-2">
                Наш сайт metallolom1-prokat.ru может обновлять нашу политику конфиденциальности время от времени. Мы
                сообщаем о
                любых изменениях, разместив новую политику конфиденциальности на этой странице. Мы отслеживаем
                изменения законодательства, касающегося персональных данных в Европейском Союзе и в государстве
                Россия. Если вы оставили персональные данные у нас, то мы оповестим вас об изменении в политике
                конфиденциальности. Если ваши персональные данные были введены не корректно, то мы не сможем с вами
                связаться.
            </p>
        </div>
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                Обратная связь, заключительные положения
            </h2>
            <p class="text-sm mb-2">
                Администрация сайта metallolom1-prokat.ru обязуется сохранять вашу конфиденциальность в Интернете. Мы
                уделяем
                большое значение охране предоставленных вами данных. Наша политика конфиденциальности основана на
                требованиях Общего регламента о защите персональных данных Европейского Союза (GDPR). Цели, в
                которых мы собираем персональные данные: улучшение работы нашего сервиса, осуществление контактов с
                посетителями данного сайта, новостная рассылка по электронной почте, обработка данных пользователей
                для сервиса онлайн - торговли, предоставление информации, которую запрашивал пользователь,
                осуществление услуг, связанных с направлением деятельности данного сайта, а так же для указанных
                ниже действий.
            </p>
            <p class="text-sm mb-2">
                Связаться с администрацией сайта metallolom1-prokat.ru по вопросам, связанным с политикой конфиденциальности
                можно по адресу: {{contacts.info_mail}}, либо с помощью контактной формы указанной в соответствующем
                разделе данного сайта. Если вы не согласны с данной политикой конфиденциальности, вы не можете
                пользоваться услугами сайта metallolom1-prokat.ru, в этом случае вы должны воздержаться от посещения нашего
                сайта.
            </p>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
